import { PREFIX_CLS } from '../../../common/constants';

type Props = {
  model: string;
  onApplyAuth?: (model: string) => void;
};

const ApplyAuth: React.FC<Props> = ({ model, onApplyAuth }) => {
  const prefixCls = `${PREFIX_CLS}-apply-auth`;

  return (
    <div className={prefixCls}>
      我暂时还无法实现您的需求,
      请再给我一点时间~
    </div>
  );
};

export default ApplyAuth;
